import { startsWithIgnoreCase } from './search';
import type { TUiStreamGroup } from '../types';

export function filterUiGroups(groups: TUiStreamGroup[], searchValue: string): TUiStreamGroup[] {
  const normalizedSearch = searchValue.trim();
  if (!normalizedSearch) return groups;

  return groups.reduce<TUiStreamGroup[]>((acc, group) => {
    if (startsWithIgnoreCase(group.label, normalizedSearch)) {
      acc.push(group);
      return acc;
    }

    const matchedItems = group.items.filter((item) => startsWithIgnoreCase(item.label, normalizedSearch));

    if (matchedItems.length > 0) {
      acc.push({
        ...group,
        items: matchedItems,
      });
    }

    return acc;
  }, []);
}
